import React from 'react';
import { vatDutyDetailsProps } from './props';
import { TmntText } from '../Common';

export default function VatDutyDetails({ vatDutyDetails }) {
  const {
    title,
    recipientNotChargedAddlDuties,
    extendedVatDetails,
    sandhVatNotRefundedMsg,
  } = vatDutyDetails;

  const renderListItem = (text) => (
    <p>
      <TmntText tmnt={text} />
    </p>
  );

  return (
    <div data-testid="order-details-vat">
      <h4><TmntText tmnt={title} /></h4>
      {renderListItem(recipientNotChargedAddlDuties)}
      {extendedVatDetails && (
      <>
        {Object.values(extendedVatDetails)
          .map((vatDetail, index) => renderListItem(vatDetail, index))}
      </>
      )}
      {renderListItem(sandhVatNotRefundedMsg)}
    </div>
  );
}

VatDutyDetails.propTypes = vatDutyDetailsProps;
